import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { CardGroup } from '../styled';
import { useReturnRows } from '../useReturnRows';

import OrderProduct from './OrderProduct';

type Props = {
  globalReturnReason: string | undefined;
};

const MobileTable: React.FC<Props> = ({ globalReturnReason }) => {
  const { t } = useTranslation('return');
  const { computedRows, toggleAllRows, areAllSelected } = useReturnRows();

  return (
    <>
      <FormControlLabel
        label={t('selectAllRows')}
        control={
          <Checkbox
            data-testid="toggle-rows"
            checked={areAllSelected}
            onChange={toggleAllRows}
          />
        }
      />
      <CardGroup>
        {computedRows.map(row => {
          return (
            <OrderProduct
              key={row.stableRowID}
              row={row}
              globalReturnReason={globalReturnReason}
            />
          );
        })}
      </CardGroup>
    </>
  );
};

export default MobileTable;
